module.exports = __webpack_public_path__ + "static/media/ImgEmail.2c010668.svg";